import {type NavigateFunction} from "react-router-dom";
import {type store} from "../../../store/store";
import {type Configuration} from "../types";
import {addSuccessText, defaultValues} from "./constants";
import {addAsync} from "./addSlice";
import {mapConfigurationToDto} from "../mappers";
import {displayUserMessage} from "../../message-panel/messagesSlice";
import {errorUserMessage, successUserMessage} from "../../message-panel/actions";

export const hasConfigurationChanged = (configuration: Configuration) => {
  for (const key in configuration) {
    if (shouldSkip(key, configuration)) {
      continue;
    }

    if (hasPropertyChanged(configuration, key)) {
      return true;
    }
  }

  return false;
};

const shouldSkip = (key: string, configuration: Configuration): boolean =>
  key.startsWith("type_") && !configuration[key] && !defaultValues[key];

const hasPropertyChanged = (configuration: Configuration, key: string) => {
  const property =
    typeof configuration[key] === "string" ? configuration[key].trim() : configuration[key];

  return property && !defaultValues[key] && property !== defaultValues[key];
};

export const onAdd = (dispatch: typeof store.dispatch, navigate: NavigateFunction) => {
  return (data: Configuration) => {
    const formData = new FormData();
    formData.append("file", data.file[0]);
    formData.append("metadata", JSON.stringify(mapConfigurationToDto(data)));

    dispatch(addAsync(formData))
      .unwrap()
      .then(
        () => {
          dispatch(displayUserMessage(successUserMessage(addSuccessText).payload));
          navigate("/");
        },
        rejected => {
          dispatch(displayUserMessage(errorUserMessage(rejected?.message).payload));
        }
      )
      .catch(err => {
        dispatch(displayUserMessage(errorUserMessage(err?.message).payload));
      });
  };
};
